/**
 *  Created by piotr@revisual.io on 04/08/2025
 */
import appConfig from "../../../../appConfig";
import classNames from "classnames";
import { useMemo } from "react";

const introCopy =
  "We’re excited to help you create impactful visuals. A few quick questions will help us tailor your Revisual experience to your needs.";

const sources = [
  "Google Search",
  "AI Assistant (ChatGPT, Claude, etc.)",
  "LinkedIn",
  "Facebook / Instagram",
  "Online Ad",
  "Referred by a colleague",
  "YouTube / Tutorial Video",
  "Other",
];

/**
 *
 * @param {Object} form
 * @param {function} setFormField
 * @param {Object} errors
 * @returns {JSX.Element}
 * @constructor
 */
export const HowDidYouHearAboutUs = ({ form, setFormField, errors }) => {
  const sourcesOptions = useMemo(
    () =>
      sources.map((source, index) => (
        <option
          key={source}
          value={source}
          selected={source === form.howDidYouHear}
        >
          {source}
        </option>
      )),
    [form]
  );

  return (
    <div>
      <h3 className="account-title">How did you hear about us?</h3>
      <p className="text-muted">{introCopy}</p>
      {/* Here you can add a form or other components to collect user information */}
      <form>
        <div className="form-group">
          <label htmlFor="fullName">Select a source</label>
          <select
            className={classNames("form-control", {
              "is-invalid": errors.howDidYouHear,
            })}
            id="howDidYouHear"
            onChange={setFormField("howDidYouHear")}
          >
            <option value={"-"}>Please choose...</option>
            {sourcesOptions}
          </select>{" "}
          <small className={"text-danger"}>{errors.howDidYouHear}</small>
          <input
            id={"howDidYouHearOther"}
            type={"text"}
            value={form.howDidYouHearOther}
            onChange={setFormField("howDidYouHearOther")}
            className={classNames("form-control mt-2", {
              "d-none": form.howDidYouHear !== "Other",
              "is-invalid": errors.howDidYouHearOther,
            })}
            placeholder={"If 'Other', please specify..."}
          />
          <small className={"text-danger"}>{errors.howDidYouHearOther}</small>
        </div>
      </form>
    </div>
  );
};

export default HowDidYouHearAboutUs;
